<template>
	<div v-if="bodyShow" class="task-box">
		<div class="task-title">
			T1：行业、赛道、趋势
		</div>
		<!--  -->
		<router-link class="task-gl" :to="{path:'/project1_ind_report'}">
			<img src="../../../assets/hxz.png" >
			行业调研参考资料
		</router-link>
		<!--  -->
		<div class="task_f">
			<h3 class="label">我想从事的目标行业是什么？</h3>
			<div :class="['input-box','input-mt',tradeShow==1?'on':'']">
				<div  v-if="tradeShow!=1" >
					<input @input="changeState" v-model="trade" type="text" placeholder="请填写你未来想从事的行业" />
				</div>
				<span v-if="tradeShow!=1" class="float">{{trade.length}}/8</span>
				<van-cell-group class="grouping on" v-else>
          <van-field placeholder="如果没有转行的计划，请选择你当前的行业" v-model="trade" @click="pickerType(1)" readonly />
          <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
        </van-cell-group>
			</div>
		</div>
		<!--  -->
		<div class="task_f">
			<h3 class="label">要了解这个行业的行业热点、行业洞察、细分赛道，有哪些好的 <span @click="alertModule2 = true" class="noun">专业信息渠道</span>？ <span class="accent">（最多列出5个）</span></h3>
			<div class="input-mt">
				<textarea @input="changeState" v-model="verticalmedia" placeholder="可以参考任务攻略，多个答案请用“/”区隔"></textarea>
			</div>
			<span class="float">{{verticalmedia.length}}/40</span>
		</div>
		<!--  -->
		<div class="task_f">
			<h3 class="label">这个行业近两年的热点、趋势和发展方向是什么？</h3>
			<div class="input-mt">
				<textarea @input="changeState" v-model="trend" placeholder="可以参考任务攻略，多个答案请用“/”区隔"></textarea>
			</div>
			<span class="float">{{trend.length}}/80</span>
		</div>
		<!--  -->
		<div class="task_f">
			<h3 class="label">这个行业有哪些 <span @click="alertModule1 = true" class="noun">行业细分赛道</span> ？<span class="accent">（最多列出5个）</span></h3>
			<div class="input-mt" v-if="trackShow!=1">
				<textarea @input="changeState" v-model="track" placeholder="填写要求：答案请尽可能的精简美观，并用“/”区隔"></textarea>
			</div>
			<span class="float" v-if="trackShow!=1">{{track.length}}/40</span>

			<div v-else :class="['input-box','input-mt',trackShow==1?'on':'']">
				<van-cell-group class="grouping on"  >
					<van-field placeholder="请优先选择你感兴趣，并且有发展前景的赛道" v-model="track" @click="pickerType(2)" readonly />
					<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
				</van-cell-group>
			</div>

		</div>
		<!--  -->
		<div class="task_f">
			<h3 class="label">在你感兴趣的细分赛道中，有哪些头部公司？ <span class="accent">（最多列出5个）</span></h3>
			<div class="input-mt">
				<textarea @input="changeState" v-model="topcompany" placeholder="可以参考任务攻略，多个答案请用“/”区隔"></textarea>
			</div>
			<span class="float">{{topcompany.length}}/40</span>
		</div>
		<!--  -->
		<div class="task_f">
			<h3 v-if="!is_main || cid >= 7" class="label">在你感兴趣的细分赛道中，有哪些适合你下一步从事的职位？ <span class="accent">（最多列出5个）</span></h3>
			<h3 v-else class="label">根据你的理解，什么样的人（包括：能力、资源、个性）特别适合这个领域？</h3>
			<div class="input-mt">
				<textarea v-if="!is_main || cid >= 7" @input="changeState" v-model="next_job" placeholder="可以参考任务攻略，多个答案请用“/”区隔"></textarea>
				<textarea v-else @input="changeState" v-model="kindperson" placeholder="请用一句话描述，不超过126个字"></textarea>
			</div>
			<span v-if="!is_main || cid >= 7" class="float">{{next_job.length}}/40</span>
			<span v-else class="float">{{kindperson.length}}/126</span>
		</div>
		<!-- 跳转项目攻略 -->
		<router-link v-if="!is_main || cid >= 7" class="task-gl" :to="{
			path:'/faq_list',
			query:{
				cid:this.$route.query.cid,
				cpid:this.$route.query.pid
			}
		}">
			<img src="../../../assets/hxz.png" >
			快速查看任务攻略
		</router-link>
		<!-- 提交按钮 -->
		<div class="task-footer">
			<div @click="submitData" :class="[isAdopt ? 'active' : '', 'submit-task']">提交</div>
		</div>
		<!-- 弹出层 -->
		<van-popup :close-on-click-overlay="false" v-model="nextModule">
			<div class="modules">
				<div class="head clearfix">
					<img @click="goTaskIndex" class="close" src="../../../assets/close.png" alt="" />
				</div>
				<div class="con-img">
					<img src="../../../assets/pr1.png" alt="" />
				</div>
				<div class="con-text">
					任务就像消消乐，完成就好，继续加油！
				</div>
				<router-link class="next-btn" :to="{path: 'project1_task2_new', query: objArg}">去开启下一任务</router-link>
			</div>
		</van-popup>
		<!-- 弹出内容1 -->
		<van-popup class="explain" v-model="alertModule1">
			<div>
				<h2>行业细分赛道:</h2>
				<div class="pps">
						行业细分赛道是行业内进一步细分的业务方向。比如说互联网领域里就有“社交、工具、媒体、电商、支付……”等很多赛道。有的行业按照客户2B、2C分，有的行业按照技术分，也有按照客户年龄地域分的。
				</div>
			</div>
		</van-popup>
		<!-- 弹出内容2 -->
		<van-popup class="explain" v-model="alertModule2">
			<div>
				<h2>专业信息渠道</h2>
				<div class="pps">
						行业内专属行业信息的发布渠道；不同于大众媒体，专业人士会在这里获得更多专业信息。一般有行业垂直媒体（如多知网）、大网站的专栏（新浪科技频道）、个人意见领袖的公众号、行业杂志、行业峰会等。
				</div>
			</div>
		</van-popup>
		<!-- 弹出下拉框 -->
		<van-popup class="tarde-pop" v-model="picker_show" position="bottom">
				<!-- 行业行业 -->
				<van-picker v-if="picker_type==1" show-toolbar :columns="obj.name"    @cancel="cancel" @confirm="confirm" />
				<!-- 细分赛道 -->
				<div class="style_tags" v-if="picker_type==2" @click="confirm(track_list)">
					<div class="track-btn">
						<a class="left" size='mini' type="default" @click="picker_show=false">取消</a>
						<a class="right" size='mini' type="info" @click="picker_show=false">确认</a>
					</div>
					<van-checkbox-group v-model="track_list">
							<van-checkbox @click="track_list_handle(item.name)" v-for="item in trackGroup" :key="item.id"  :disabled="track_list.indexOf(item.name)<0 && track_list.length>=5" :name="item.name">{{item.name}}</van-checkbox>
					</van-checkbox-group>
				</div>
		</van-popup>
	</div>
</template>
<script>
	import { getresearchdata, updateresearchdata } from "@/api/course"
	import { getStorage, setStorage,isMain } from "@/utils/tools"
	import {
  shareCon
} from "@/utils/wxconfig";
	export default {
		data(){
			return {
				bodyShow:false,
				nextModule: false,
				alertModule1: false,
				alertModule2: false,
				isAdopt: false,
				trade: "",
				track: "",
				topcompany: "",
				trend: "",
				verticalmedia: "",
				kindperson: "",
				objArg: {
					cid: "",
					pid: "",
					id: "",
					name: ""
				},
				arrow:false,
				picker_type:0,
				picker_show:false,
				obj:{
					id:[],
					name:[]
				},
				trackGroup:[],
				next_job:'',
				jobGroup:[],
				tradeShow:0,
				trackShow:0,
				cid:'',
				track_list:[],
				data:{}
			}
		},
		computed: {
			is_main(){
				return isMain()
			}
		},
		methods: {
			// 行业细分赛道
			track_list_handle(name){
					if(this.track_list.indexOf(name)<0 && this.track_list.length>=5){
							this.$toast('最多选择5个哦！');
					}
			},
			cancel(data){
					this.picker_show=false;
			},
			// 弹出选择框  1 目标行业 2行业细分赛道
			confirm(data){
					if(this.picker_type==1){
							this.trackGroup = [];
							for(let i=0;i<this.obj.name.length;i++){
								// 判断是否等于列表的数据
								if(data == this.obj.name[i]){
									// 循环判断显示对应行业细分赛道
									for(let j=0;j<this.jobGroup.length;j++){
										if(this.obj.id[i] == this.jobGroup[j].pid){
											this.trackGroup.push({id:this.jobGroup[j].id,name:this.jobGroup[j].name});
										}
									}
								}
							}
							if(data == '其他'){
								this.tradeShow = 0;
								this.trackShow = 0;
							}else{
								this.trackShow = 1;
							}
							this.track = '';
							this.trade = data;
							this.picker_show=false;
					}else if(this.picker_type==2){
							this.trackShow = 0;
							this.track = this.track_list.join('/');
					}

			},
			// 判断弹出是什么选择框
			pickerType(type){
					// 1 工作年限、2目前所处行业、3岗位职级、4岗位职能
					if(type == 2 && this.trade == ''){
						this.$toast('请先选择目标行业哦~');
					}else{
						this.picker_type=type;
						this.picker_show=true;
					}


			},
			goTaskIndex(){
				let q = this.$route.query
				this.$router.push({
					path: 'project_details',
					query: {
						cid: q.cid,
						cpid: q.pid,
						type: 'trademap'
					}
				})
			},
			showModule(){
				this.alertModule = true;
			},
			changeState(ev, key){
				// 判断用户是否以前提交过
				this.execState();
			},
			execState(){
				if(
						this.trade.length &&
						this.track.length &&
						this.topcompany.length &&
						this.trend.length &&
						this.verticalmedia.length &&
						((!this.is_main || this.cid >= 7)?this.next_job.length:this.kindperson.length)
					){
					this.isAdopt = true;
				}else{
					this.isAdopt = false;
				}
			},
			submitData(){
				if(!this.isAdopt){
					return
				}
				// 提交
				let q = this.$route.query;
				updateresearchdata({
					cid: q.cid,
					cpid: q.pid,
					cptid: q.id,
					type: "taskone",
					iscreate: 1,
					trade: this.trade,
					track: this.track,
					topcompany: this.topcompany,
					trend: this.trend,
					verticalmedia: this.verticalmedia,
					next_job:(!this.is_main || this.cid >= 7)?this.next_job:'',
					kindperson:(!this.is_main || this.cid < 7)?this.kindperson:''
				})
				.then((data) => {
					let d = data;
					let q = this.$route.query;
					this.objArg = {
						cid: q.cid,
						pid: q.pid,
						id: d.cptid,
						name: encodeURIComponent(d.name)
					}
					// show module
					this.nextModule = true;
				})
			},
			pullData(){
				getresearchdata({
					cid: this.$route.query.cid,
					type: "taskone"
				})
				.then((data) => {
					this.bodyShow = true;
					this.data = data.data;
					this.cid = this.$route.query.cid;
					// 给下拉框赋值
					// 目标行业
					for(let i=0;i<data.profession.length;i++){
						this.obj.id.push(data.profession[i].id);
						this.obj.name.push(data.profession[i].name);
						if(data.profession[i].name == data.data.trade || data.data.trade == ''){
							this.tradeShow = 1;
						}
					}

					this.jobGroup = data.job;

					let {
								kindperson,
								next_job,
								topcompany,
								track,
								trade,
								trend,
								verticalmedia
							} = data.data;
					if(
						((!this.is_main || this.cid >= 7)?next_job:kindperson) &&
						topcompany &&
						track &&
						trade &&
						trend &&
						verticalmedia
					){
						// 设置服务器已提交的数据
						this.setDataVal(true, data.data);
					}else{
						this.setDataVal(false);
					}

				})
			},
			setDataVal(bool, d){
				let path = this.$route.path;
				this.kindperson = bool ? d.kindperson : getStorage(path, 'kindperson') || '';
				this.next_job = bool ? d.next_job : getStorage(path, 'next_job') || '';
				this.topcompany = bool ? d.topcompany : getStorage(path, 'topcompany') || '';
				this.track = bool ? d.track : getStorage(path, 'track') || '';
				this.trade = bool ? d.trade : getStorage(path, 'trade') || '';
				this.trend = bool ? d.trend : getStorage(path, 'trend') || '';
				this.verticalmedia = bool ? d.verticalmedia : getStorage(path, 'verticalmedia') || '';


				// 把字符串转为数组
				let trade_list = this.trade.split('/');

				if(this.trade == ''){
					this.trackShow = 1;
				}else if(this.trade != ''){
					for(let i=0;i<trade_list.length;i++){
						// 判断是否等于列表的数据
						if(this.obj.name[trade_list[i]]){
							this.trackShow = 1;
						}else{
							this.trackShow = 0;
						}
					}
				}else{
					this.trackShow = 0;
				}


				// 判断时候允许提交
				this.execState();
			},
			setTitle(){
				let title = this.$route.query.name;
				document.title = decodeURI(title);
			}
		},
		created(){
			this.pullData();
			this.setTitle();
			shareCon("course",this);
		},
		watch: {
			trade(curVal, oldVal){
				if(curVal.length > 8) {
		      this.trade = curVal.slice(0, 8);
		      this.$toast('最多只能输入8个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'trade', curVal);
				}
			},
			track(curVal, oldVal){
				if(curVal.length > 40) {
		      this.track = curVal.slice(0, 40);
		      this.$toast('最多只能输入40个字。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'track', curVal);
				}
			},
			topcompany(curVal, oldVal){
				if(curVal.length > 40) {
		      this.topcompany = curVal.slice(0, 40);
		      this.$toast('最多只能输入40个字。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'topcompany', curVal);
		    }
			},
			trend(curVal, oldVal){
				if(curVal.length > 80) {
		      this.trend = curVal.slice(0, 80);
		      this.$toast('最多只能输入80个字。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'trend', curVal);
		    }
			},
			verticalmedia(curVal, oldVal){
				if(curVal.length > 40) {
		      this.verticalmedia = curVal.slice(0, 40);
		      this.$toast('最多只能输入40个字。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'verticalmedia', curVal);
		    }
			},
			kindperson(curVal, oldVal){
				if(curVal.length > 126) {
		      this.kindperson = curVal.slice(0, 126);
		      this.$toast('最多只能输入126个字。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'kindperson', curVal);
		    }
			},
			next_job(curVal, oldVal){
				if(curVal.length > 40) {
		      this.next_job = curVal.slice(0, 40);
		      this.$toast('最多只能输入40个字。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'next_job', curVal);
		    }
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/taskStyle.scss";
	.input-box.on {
		padding-left: 0;
		background-color: transparent
	}
	.task-gl{
		display: block;
		margin-top: 40px;
		font-size:26px;
		color: #666;
		text-decoration:underline;
		img{
			width:28px;
			height: 28px;
			margin-right: 12px;
		}
	}
	.tarde-pop{
		overflow-y: hidden;
	}
	.style_tags{
		position: relative;
		padding-top: 80px;
	}
	.style_tags_active{
		color: #dfdfdf;
		opacity: .6;
	}
	.track-btn{
		position:absolute;
		width: 100%;
		left: 0;
		top: 0;
		color: #1989fa;
		display: flex;
		font-size: 26px;
		height: 80px;
		line-height: 80px;
		padding: 0 30px;
		.right{
			margin-left: auto;
		}
	}
</style>
<style>
    .style_tags .van-checkbox-group{
        width:100%;
				height: 400px;
				overflow-y: scroll;
        font-size:0;
        padding: 30px;
        border-radius: 8px;
    }
    .style_tags .van-checkbox-group .van-checkbox{
        width:50%;
        display: inline-block;
        font-size: 26px;
        margin-top:40px;
    }
    .style_tags .van-checkbox-group .van-checkbox .van-checkbox__label{
        position: relative;
        z-index:2;
        padding:10px 0px 10px 45px;
        margin-left: -35px;
    }
    .style_tags .van-checkbox-group .van-checkbox:nth-child(1),.style_tags .van-checkbox-group .van-checkbox:nth-child(2){
        margin-top:0px;
    }
    .style_tags .van-checkbox-group .van-checkbox .van-checkbox__icon{
        height: auto;
        line-height:auto;
    }
    .style_tags .van-checkbox-group .van-checkbox .van-checkbox__icon .van-icon{
        width:34px;
        height: 34px;
        border:0;
        border-radius: 0;
        border-color: transparent;
        background-color: transparent;
        background-image: url(../../../assets/normal.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .style_tags .van-checkbox-group .van-checkbox__icon.van-checkbox__icon--checked .van-icon.van-icon-success{
        background-image: url(../../../assets/press.png);
    }
    .style_tags .van-checkbox-group .van-checkbox .van-checkbox__icon .van-icon:before{
        content:'';
    }
</style>
